export const categoryOptions = [
  { text: "Select", value: "" },
  { text: "Painting", value: "Painting" },
  { text: "Sculpture", value: "Sculpture" },
  { text: "Photography", value: "Photography" },
  { text: "Print", value: "Print" },
  {
    text: "Drawing, Collage or other Work on Paper",
    value: "Drawing, Collage or other Work on Paper",
  },
  { text: "Mixed Media", value: "Mixed Media" },
  { text: "Performance Art", value: "Performance Art" },
  { text: "Installation", value: "Installation" },
  { text: "Video/Film/Animation", value: "Video/Film/Animation" },
  { text: "Architecture", value: "Architecture" },
  {
    text: "Fashion Design and Wearable Art",
    value: "Fashion Design and Wearable Art",
  },
  { text: "Jewelry", value: "Jewelry" },
  { text: "Design/Decorative Art", value: "Design/Decorative Art" },
  { text: "Textile Arts", value: "Textile Arts" },
  { text: "Posters", value: "Posters" },
  { text: "Books and Portfolios", value: "Books and Portfolios" },
  { text: "Other", value: "Other" },
  { text: "Ephemera or Merchandise", value: "Ephemera or Merchandise" },
  { text: "Reproduction", value: "Reproduction" },
  { text: "NFT", value: "NFT" },
]
